import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyResultError from './EmptyResultError';
import { ErrorNames } from '../../../constants';

import s from './EmptyResult.scss';

export interface Props {
  errorName: ErrorNames;
}

const EmptyResultDueToSettings: FC<Props> = ({ errorName }) => {
  const { t } = useTranslation();
  return (
    <div className={s['empty-state-root']}>
      <div className={s['empty-state-label']}>
        {t([
          `searchPage.emptyState.title.${errorName}`,
          'facetPage.emptyState.title',
        ])}
      </div>
      <div className={s['empty-state-error']}>
        <EmptyResultError errorName={errorName} />
      </div>
    </div>
  );
};
EmptyResultDueToSettings.displayName = 'EmptyResultDueToSettings';

export default EmptyResultDueToSettings;
